import React, { memo, useEffect } from 'react';
import * as CSS from './WorldTrackingPlacementUI.scss';
import { useUserStore } from '@/zustand';

export type IWorldTrackingMode = 'initializing' | 'placed' | 'intersecting' | 'intersecting-no-animation' | 'searching' | 'searching-no-animation';

interface IParentProps {
	onReset: () => unknown;
	onPlace: () => unknown
	enabled?: boolean;
	mode: IWorldTrackingMode;
};

const WorldTrackingPlacementUI: React.FC<IParentProps> = ({ onReset, onPlace, enabled = false, mode }) => {
	const placementModeUiVisible = useUserStore(({ placementModeUiVisible }) => placementModeUiVisible);
	const canvasDiv = document.getElementById('zapparCanvas');

	useEffect(() => {
		if (!enabled) return;
		if (!canvasDiv) return;

		const containerDiv = document.createElement('div');
		containerDiv.id = 'worldPlacementUiContainer';
		containerDiv.className = CSS.Container;
		containerDiv.style.height = '100%';
		containerDiv.style.position = 'absolute';

		const placeHandler =  (e: PointerEvent) => {
			if (mode === 'placed') return;
			e.stopPropagation();
			onPlace();
		}

		let uiElement: HTMLElement | null = null;
		switch (mode) {
			case 'placed':
				uiElement = document.createElement('button');
				uiElement.id = 'wtPlacementButton';
				uiElement.className = CSS.PlacementButton;
				uiElement.addEventListener('pointerdown', e => e.stopPropagation());
				uiElement.addEventListener('pointerup', e => e.stopPropagation());
				uiElement.innerText = 'Reset';
				uiElement.addEventListener('click', e => {
					e.stopPropagation();
					onReset();
				})
				break;
			case 'intersecting':
			case 'intersecting-no-animation':
				uiElement = document.createElement('div')
				uiElement.id = 'wtSurfaceFoundDiv';
				uiElement.className = CSS.InfoDiv;
				uiElement.innerText = 'Surface found - Tap to place'
				document.addEventListener('pointerdown', placeHandler)
				break;
			case 'searching':
			case 'searching-no-animation':
				uiElement = document.createElement('div')
				uiElement.id = 'wtSurfaceLostDiv';
				uiElement.className = CSS.InfoDiv;
				uiElement.style.width = '170px';
				uiElement.innerText = 'Finding surface...'
				break;
		}
		
		if (uiElement) containerDiv.appendChild(uiElement);
		canvasDiv.appendChild(containerDiv);

		return () => {
			const canvasDiv = document.getElementById('zapparCanvas');
			const containerDiv = document.getElementById('worldPlacementUiContainer');
			if (!canvasDiv || !containerDiv) return;
			canvasDiv.removeChild(containerDiv);
			document.removeEventListener('pointerdown', placeHandler)
		};
	}, [enabled, mode, placementModeUiVisible]);

	return null;
};

export default memo(WorldTrackingPlacementUI);
